import { RouteObject } from 'react-router-dom';

import FirmwareManagementPage from '../../pages/firmware-management';

export const firmwareManagementRouter: RouteObject = {
  path: '/firmware-management',
  element: <FirmwareManagementPage />,
};

export default firmwareManagementRouter;
